import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "genderSelect",
    "preferredNameWrapper",
    "preferredNameField",
  ];

  connect() {
    this.preferredNameField = this.preferredNameFieldTarget;
    this.update();
  }

  update() {
    if (this.genderSelectTarget.value.includes("trans")) {
      this.preferredNameWrapperTarget.classList.remove("d-none");
      if (!this.preferredNameWrapperTarget.contains(this.preferredNameField)) {
        this.preferredNameWrapperTarget.appendChild(this.preferredNameField);
      }
    } else {
      if (this.preferredNameWrapperTarget.contains(this.preferredNameField)) {
        this.preferredNameWrapperTarget.classList.add("d-none");
        this.preferredNameField.remove();
      }
    }
  }
}
